var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { defer } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { catchError, map } from 'rxjs/operators';
import { addCsrfTokenHeader, getCsrfToken } from '../csrf';
import { InternalServerError, ValidationException } from '../exceptions';
export var getJson = function (apiUrl, options, retried) {
    if (options === void 0) { options = {}; }
    if (retried === void 0) { retried = false; }
    return ajax.getJSON(apiUrl, createHeadersWithCsrf(options)).pipe(catchError(function (err) {
        if (retried)
            throw err;
        return handleErrorsOrRetry(getJson(apiUrl, options, true))(err);
    }));
};
export var postJson = function (apiUrl, request, options, retried) {
    if (options === void 0) { options = {}; }
    if (retried === void 0) { retried = false; }
    return ajax({
        url: apiUrl,
        headers: createHeadersWithCsrf(options, request),
        method: 'POST',
        body: request instanceof FormData ? request : JSON.stringify(request),
    }).pipe(map(function (response) { return assertSuccessfulResponse(response); }), catchError(function (err) {
        if (retried)
            throw err;
        return handleErrorsOrRetry(defer(function () { return postJson(apiUrl, request, options, true); }))(err);
    }));
};
var assertSuccessfulResponse = function (response) {
    if (response.status < 400)
        return response.response;
    throw response;
};
var handleErrorsOrRetry = function (retry$) {
    return function (err) {
        if (err.status === 403) {
            return retry$;
        }
        if (err.status === 400) {
            var errorBody = err.response;
            throw new ValidationException(errorBody.ValidationErrors, err);
        }
        throw new InternalServerError('Unexpected error occurred', err);
    };
};
var createHeadersWithCsrf = function (options, request) {
    if (options === void 0) { options = {}; }
    var headers = options.headers;
    return request instanceof FormData
        ? options.headers
        : __assign(__assign({}, addCsrfTokenHeader(getCsrfToken(), headers)), { 'Content-Type': 'application/json' });
};
//# sourceMappingURL=index.js.map